import Model from '../utils/Model'

class SailingDay {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'SailingDay'

export const MON_SAILING_DAY = new SailingDay('MON', '周一', 'MON')
export const TUE_SAILING_DAY = new SailingDay('TUE', '周二', 'TUE')
export const WED_SAILING_DAY = new SailingDay('WED', '周三', 'WED')
export const THU_SAILING_DAY = new SailingDay('THU', '周四', 'THU')
export const FRI_SAILING_DAY = new SailingDay('FRI', '周五', 'FRI')
export const SAT_SAILING_DAY = new SailingDay('SAT', '周六', 'SAT')
export const SUN_SAILING_DAY = new SailingDay('SUN', '周日', 'SUN')

export const SAILING_DAYS = [MON_SAILING_DAY, TUE_SAILING_DAY, WED_SAILING_DAY, THU_SAILING_DAY, FRI_SAILING_DAY, SAT_SAILING_DAY, SUN_SAILING_DAY]

export function getSailingDayByCode(code) {
  return Model.getObjByCode(code, SAILING_DAYS)
}
